import React, {forwardRef} from "react";

type Props = {
	children: React.ReactNode
	className?: string
	headerClassName?: string
	bodyClassName?: string
	removePaddings?: boolean
	title?: string | React.ReactNode
	style?: React.CSSProperties
	afterTitle?: React.ReactNode
}

export const SimpleCard = forwardRef((props: Props, ref: React.ForwardedRef<HTMLDivElement>) => {
	return <div className={`bg-main-bg shadow-lg rounded-2xl items-center ${props.className || ''}`} style={props.style || {}} ref={ref}>
		{props.title && (typeof props.title == 'string' ? props.title.length > 0 : true) ? (
			<div className={`flex-grow flex items-center py-6 px-4 pb-3 lg:px-6 xl:px-8 rounded-t-2xl min-h-[40px] ${props.headerClassName || ''}`}>
				{typeof props.title == 'string' ? <p className="h4 mr-auto">
					{props.title}
				</p> : props.title}
				{props.afterTitle || null}
			</div>
		) : null}
		<div className={`${!props.removePaddings && `py-6 lg:py-6 px-4 lg:px-6 xl:px-8`} rounded-b-2xl ${!props.title && !props.removePaddings && `pt-6`} ${props.bodyClassName || ''}`}>
			{props.children}
		</div>
	</div>
});

export default SimpleCard;